import { render, staticRenderFns } from "./Segasec.vue?vue&type=template&id=661da1b7&"
import script from "./Segasec.vue?vue&type=script&lang=js&"
export * from "./Segasec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports